'use strict';

module.exports = require('react/lib/ReactDOMServer');



/*****************
 ** WEBPACK FOOTER
 ** /Users/nw/motion/js-deps/~/react-dom/server.js
 ** module id = 303
 ** module chunks = 1
 **/